import * as React from 'react';
import { ReactComponent as SlashcallLogo } from '../../assets/slashcall/slashcall-logo-white.svg';

const FEATURES = [
	{ icon: 'feature-type.svg', label: 'Just type what you need' },
	{ icon: 'feature-route.svg', label: 'Route calls. Delight customers.' },
	{ icon: 'feature-results.svg', label: 'Powerful results. Zero complexity.' },
];

/**
 * Left-panel branding shown on the Login and Reset-Password pages when the app is
 * served from the SlashCall domain (hub.slashcall.com).
 */
function SlashcallBranding() {
	return (
		<div className="slashcall-branding">
			<SlashcallLogo className="slashcall-logo" role="img" aria-label="Slashcall" />
			<h1 className="slashcall-headline">
				<span className="slashcall-headline-1">Your Contact Center.</span>
				<span className="slashcall-headline-2">No Manager Required</span>
			</h1>
			<p className="slashcall-subtitle">
				Set it up in minutes. Run it with confidence.
				<br />
				All you need to do is type.
			</p>
			<div className="slashcall-features">
				{FEATURES.map((feature) => (
					<div className="slashcall-feature-card" key={feature.icon}>
						<img
							className="slashcall-feature-icon"
							src={`${process.env.PUBLIC_URL}/slashcall/icons/${feature.icon}`}
							alt=""
							aria-hidden="true"
						/>
						<span className="slashcall-feature-label">{feature.label}</span>
					</div>
				))}
			</div>
		</div>
	);
}

export default SlashcallBranding;
